module.exports = __webpack_public_path__ + "img/addmodel.6482da70.gif";